// Currency formatting
export const formatCurrency = (amount, currency = 'GBP') => {
  const symbol = currency === 'EUR' ? '€' : '£';
  return `${symbol}${parseFloat(amount || 0).toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

// Date formatting
export const formatDate = (date) => {
  if (!date) return 'N/A';
  // BUG FIX: `new Date(dateString)` parses a bare "YYYY-MM-DD" string as UTC
  // midnight. Depending on the browser's timezone offset relative to UTC,
  // that can display as the wrong calendar day entirely — the classic
  // off-by-one date bug. Extracting just the date portion and parsing it at
  // local noon avoids any midnight-boundary ambiguity, regardless of
  // timezone (same safe pattern already used elsewhere in the app).
  const datePart = String(date).substring(0, 10);
  const d = new Date(datePart + 'T12:00:00');
  if (isNaN(d.getTime())) return 'N/A';
  return d.toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric'
  });
};

// Month formatting
export const formatMonth = (monthStr) => {
  if (!monthStr) return 'N/A';
  const [year, month] = monthStr.split('-');
  const date = new Date(year, month - 1);
  return date.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
};

// Get current month string (YYYY-MM)
export const getCurrentMonth = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

// Get last 12 months
export const getLast12Months = () => {
  const months = [];
  const now = new Date();
  for (let i = 0; i < 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    months.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
  }
  return months;
};

// Occupied rooms count
export const getOccupiedRooms = (property) => {
  const rooms = property.rooms || [];
  return rooms.filter(r => r.status === 'occupied').length;
};

// Total monthly rent for a property
export const getTotalMonthlyRent = (property) => {
  const rooms = property.rooms || [];
  return rooms
    .filter(r => r.status === 'occupied')
    .reduce((sum, r) => sum + (parseFloat(r.rentAmount) || 0), 0);
};

// Check if payment was made for a room in a month
export const isPaymentMade = (payments, propertyId, roomId, month) => {
  return payments.some(p =>
    p.property_id === propertyId &&
    p.room_id === roomId &&
    p.month === month
  );
};

// Get status badge class
export const getStatusBadge = (status) => {
  const map = {
    occupied: 'badge-success',
    vacant: 'badge-danger',
    approved: 'badge-success',
    pending: 'badge-warning',
    rejected: 'badge-danger',
    locked: 'badge-danger',
    revoked: 'badge-secondary',
    active: 'badge-success',
    completed: 'badge-info',
    archived: 'badge-secondary'
  };
  return map[status] || 'badge-secondary';
};

// Truncate text
export const truncate = (text, length = 50) => {
  if (!text) return '';
  return text.length > length ? `${text.substring(0, length)}...` : text;
};

// Export to CSV
export const exportToCSV = (data, filename) => {
  if (!data || data.length === 0) return;
  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map(row => headers.map(h => `"${row[h] || ''}"`).join(','))
  ].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
